import { useParamsContext } from '../../contexts/ParamsContext';
import ClientesList from './List';
import MessageView from './MessageView';

export default function Clientes() {
    const { action } = useParamsContext();

    switch (action) {
        case 'mensagem': {
            return <MessageView />;
        }
        case 'mensagem-push-all': {
            return <MessageView forcePushEmailOnly forceAll />;
        }
        case 'list':
        default:
            return <ClientesList />;
    }
}
